import { useEffect, useState } from "react";
import { apiFetchJson } from "../apiClient";

const API = "/api/v1";
const RUN_HISTORY_LIMIT = Number(
  (window._env_ && window._env_.REACT_APP_ACCURACY_TREND_RUNS) ||
    process.env.REACT_APP_ACCURACY_TREND_RUNS,
) || 12;
const PENDING_PREVIEW_LIMIT = 5;

const withDatabase = (query, database) =>
  database ? `${query}&database=${encodeURIComponent(database)}` : query;

// Loads everything the accuracy dashboard shows. Sources fail independently
// (a missing store must not blank the whole page); `error` is set only when
// every source failed, with the first failure's message.
export default function useQualityMetrics(database = "", sinceDays = 30) {
  const [state, setState] = useState({ loading: true, error: null });

  useEffect(() => {
    let cancelled = false;
    setState({ loading: true, error: null });
    (async () => {
      const [usage, feedback, runs, pending] = await Promise.allSettled([
        apiFetchJson(withDatabase(`${API}/usage/statistics?since_days=${sinceDays}`, database)),
        apiFetchJson(withDatabase(`${API}/feedback/statistics?since_days=${sinceDays}`, database)),
        apiFetchJson(withDatabase(`${API}/accuracy/runs?limit=${RUN_HISTORY_LIMIT}`, database)),
        apiFetchJson(withDatabase(`${API}/feedback?status=pending&limit=${PENDING_PREVIEW_LIMIT}`, database)),
      ]);
      const value = (r) => (r.status === "fulfilled" ? r.value : null);
      const runItems = value(runs)?.items ?? null;
      let latestRun = null;
      if (runItems && runItems.length) {
        try {
          latestRun = await apiFetchJson(`${API}/accuracy/runs/${runItems[0].id}`);
        } catch {
          latestRun = null;
        }
      }
      if (cancelled) return;
      const all = [usage, feedback, runs, pending];
      setState({
        loading: false,
        error: all.every((r) => r.status === "rejected") ? all[0].reason.message : null,
        usage: value(usage),
        feedback: value(feedback),
        runs: runItems,
        latestRun,
        pending: value(pending)?.items ?? null,
      });
    })();
    return () => {
      cancelled = true;
    };
  }, [database, sinceDays]);

  return state;
}
